import { ISelectOptions } from "../../../types/inputs";
import { Button } from "../../Atoms/Button";
import { InputSwitch } from "../../Atoms/Inputs/InputSwitch";
import { SimpleSelect } from "../../Atoms/Selects/SimpleSelect";
import { TextArea } from "../../Atoms/TextArea";
import { Title } from "../../Atoms/Title";
import { useDelayNotification } from "./useDelayNotification";
import * as S from "./styles";

export const DelayNotificationTemplate = () => {
    const { motivosOptions, submitForm, form, setForm } = useDelayNotification();

    return (
        <S.Container>
            <S.Wrapper>
                <Title>Comunicar Atraso</Title>
            
                <S.FormComunicacaoAtraso onSubmit={(e) => {
                    e.preventDefault();
                    submitForm(form);
                }}>
                    <div>
                        <SimpleSelect
                            isDisabled={form?.outroMotivo}
                            label="Motivo"
                            options={motivosOptions}
                            onChange={(e: ISelectOptions) =>
                                setForm((prev) => ({ 
                                    ...prev, 
                                    uuidMotivo: e?.value, 
                                    outroMotivo: false 
                                }))
                            }
                            value={
                                motivosOptions.find((e) => e.value === form?.uuidMotivo) || null
                            }
                        />
                    </div>

                    <div>
                        <InputSwitch
                            label="Outro motivo"
                            id="ativo"
                            checked={form?.outroMotivo}
                            onChange={(e) => {
                                setForm((prev) => ({ ...prev, outroMotivo: e?.target?.checked }));
                                e?.target?.checked && setForm((prev) => ({ ...prev, uuidMotivo: null }));
                            }}
                        />
                    </div>

                    <div>
                        <TextArea 
                            label="Observação"
                            id="textarea"
                            value={form?.observacao}
                            onChange={(e) => setForm((prev) => ({ ...prev, observacao: e?.target?.value }))}
                        />
                    </div>

                    <div>
                        <Button>Avançar</Button>
                    </div>
                </S.FormComunicacaoAtraso>
            </S.Wrapper>
        </S.Container>
    );
};